import { IListing } from '../../@types/listing';
import { BaseServiceFactory } from '../types/base';
import { RentgrataServices } from './types';
import { analyticsEventActions } from '../../app/utils/constants';

export class RentgrataFactory implements BaseServiceFactory {
  listing: IListing;

  constructor(listing: IListing) {
    this.listing = listing;
  }

  create(): RentgrataServices {
    return {
      desktop: {
        chat: this.listing.has_chat_with_resident,
        schedule: this.listing.has_schedule_tour,
        hasSpecials: this.listing.has_specials,
        virtualTour: this.listing.has_virtual_tour,
        contact: this.listing.has_specials,
      },
      mobile: {
        chat: true,
        contact: this.listing.has_mobile_contact_property,
        schedule: this.listing.has_mobile_schedule_tour,
        hideLabels: this.listing.hides_mobile_feature_labels,
      },
      more: {
        chat: this.listing.has_chat_with_resident,
        schedule: this.listing.has_schedule_tour,
        hasSpecials: this.listing.has_specials,
        virtualTour: this.listing.has_virtual_tour,
        contact: true,
      },
      events: {
        opens: {
          chat: analyticsEventActions.opens_chat_with_resident,
          contact: analyticsEventActions.opens_contact_property,
          schedule: analyticsEventActions.opens_schedule_tour,
        },
      },
    };
  }
}
